export default async function ({ $axios, redirect, app, store, route, $cookies, $config }) {
    // Interceptor to check before each request

    const slug = route?.params?.pathMatch;

    if (slug) {
        try {
            await store.dispatch('builder/getPage', slug);
        } catch {}
    }

    $axios.onRequest(config => {
        // Block requests if user is unauthorized
        const siteToken = $config.TOKEN;
        const token = $cookies.get('token');

        if (siteToken) {
            $axios.setHeader('token', siteToken);
        }

        if (token) {
            $axios.setHeader('Authorization', `Bearer ${token}`);
        }
        if (store?.state?.auth?.isUnauthorized) {
            // return;
            return Promise.reject(new Error('Request canceled due to unauthorized state'));
        }
        return config;
    });

    $axios.onError(error => {
        const code = parseInt(error.response && error.response.status);

        if (code === 401) {
            if (error.response?.config?.url === '/auth/jwt/create/') {
                return Promise.reject(error);
            }

            // if (error.response?.config?.url === '/auth/jwt/refresh/') {
            if (!store.state?.auth?.isUnauthorized) {
                store.dispatch('auth/clearAllData', false);
                redirect(app.localePath({ path: '/', query: { login: true } }));
            }
            // }
        }

        if (code === 404 && error.config.redirectOnError) {
            // console.log(error.config, error.response, 'test');
            if (error.response.config.url.includes('slug_check')) {
                // if (JSON.parse(error.response.config.data).new_lang === app.$cookies.get('i18n_redirected')) {
                //     return;
                // }
            }
            redirect(app.localePath({ path: '/404' }));
        }
    });

    $axios.onResponse(response => {
        if (response.config.redirectOnError) {
            if (response.config.url.includes('slug_check')) {
                const isEmptyObject = Object.keys(route.query).length === 0;

                if (response.data.slug) {
                    if (JSON.parse(response.config.data).object_type === 'product') {
                        redirect(
                            app.localePath({
                                path: `/product/${response.data.slug}${
                                    isEmptyObject ? '' : `?${new URLSearchParams(route.query).toString()}`
                                }`
                            })
                        );
                    }
                    if (JSON.parse(response.config.data).object_type === 'category') {
                        redirect(app.localePath({ path: `/${response.data.slug}` }));
                    }
                }
            }
            if (response.data.not_found) {
                // redirect(app.localePath({ path: '/404' }));
            }
        }
        return response;
    });
}
